
<a-layout-sider
  :class="[theme, 'sider', isMobile ? null : 'shadow', fixSiderbar && !isMobile ? 'ant-fixed-sidemenu' : null]"
  width="256px"
  :collapsible="collapsible"
  :collapsed="collapsed"
  :trigger="null">
  <div :class="['logo', theme]">
    <router-link to="/home" :title="systemName">
      <img src="/static/img/logo.png" alt="" />
      <h1 v-if="!collapsed" class="animated fadeIn">{{systemName}}</h1>
    </router-link>
  </div>
  <i-menu :theme="theme" :collapsed="collapsed" :menuData="menuData" @select="onSelect"/>
</a-layout-sider>
